import React from 'react';

import { Skeleton } from 'src/component/ds/ui/skeleton';
import { ALARM_SEVERITIES } from './severity';

/**
 * Stands in for the headline count while it's being fetched.
 *
 * @returns {JSX.Element} a count-sized placeholder
 */
export function TotalSkeleton () {
  return <Skeleton className='ds-h-12 ds-w-[64px]' data-testid='alarms-to-triage-total-skeleton' />;
}

/**
 * Stands in for the breakdown. Always three bars regardless of how many
 * severities will arrive -- the count isn't known until the fetch lands, and
 * guessing would make the row jump.
 *
 * @returns {JSX.Element} a row of three bar-sized placeholders
 */
export function BreakdownSkeleton () {
  return (
    <div className='ds-flex ds-items-stretch ds-gap-2'>
      {ALARM_SEVERITIES.map((severity) => (
        <Skeleton
          key={severity}
          className='ds-h-[62px] ds-flex-1'
          data-testid='alarms-to-triage-segment-skeleton'
        />
      ))}
    </div>
  );
}
